import React, { useEffect, useRef, useState } from "react";

/**
 * Holographic blob cursor that follows the pointer.
 */
const Cursor = () => {
  const ringRef = useRef(null);
  const dotRef = useRef(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let ringX = window.innerWidth / 2;
    let ringY = window.innerHeight / 2;
    let dotX = ringX;
    let dotY = ringY;
    let mouseX = ringX;
    let mouseY = ringY;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      setHidden(false);
    };
    const onLeave = () => setHidden(true);

    const tick = () => {
      dotX += (mouseX - dotX) * 0.4;
      dotY += (mouseY - dotY) * 0.4;
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      if (dotRef.current) dotRef.current.style.transform = `translate3d(${dotX - 3}px, ${dotY - 3}px, 0)`;
      if (ringRef.current) ringRef.current.style.transform = `translate3d(${ringX - 18}px, ${ringY - 18}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerleave", onLeave);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerleave", onLeave);
    };
    // Intentional one-time setup: animation loop owns its own mutable state via closures.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        ref={ringRef}
        className="fixed top-0 left-0 pointer-events-none z-[200] mix-blend-difference"
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "1px solid rgba(255,255,255,0.7)",
          opacity: hidden ? 0 : 1,
          transition: "opacity 0.3s",
        }}
      />
      <div
        ref={dotRef}
        className="fixed top-0 left-0 pointer-events-none z-[201]"
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "#ff9eeb",
          boxShadow: "0 0 12px #ff9eeb",
          opacity: hidden ? 0 : 1,
          transition: "opacity 0.3s",
        }}
      />
    </>
  );
};

export default Cursor;
